import React from "react";

import Section from "../../Section.jsx";
import Button from "../../Button.jsx";

const HeroBanner = () => {
  return (
    <Section
      className='hero-section relative flex flex-col justify-start min-h-screen bg-cover bg-center bg-no-repeat overflow-hidden md:items-center md:justify-center !pt-0 !pb-0 !px-0'
      style={{
        backgroundImage: `url('/images/landing/hero.png')`,
      }}>
      {/* Luxury Overlay Gradient */}
      <div
        className='absolute inset-0 bg-gradient-to-r from-primary-dark/95 via-primary-dark/80 to-primary-dark/60'
        aria-hidden='true'></div>

      {/* Animated Background Accent */}
      <div className='absolute top-0 right-0 w-96 h-96 bg-accent-gold/5 rounded-full blur-3xl -z-0'></div>

      {/* Main Content - Minimal responsive padding (spacer handles navbar clearance) */}
      <div className='relative z-10 w-full pt-4 pb-6 sm:pt-6 sm:pb-10 md:pt-12 md:pb-16 lg:pt-16 lg:pb-20 px-6 sm:px-12 md:px-16 lg:px-24'>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mx-auto px-6 sm:px-12 md:px-16 lg:px-24'>

          {/* Left Side - Main Title & CTA */}
          <div className='flex flex-col justify-start space-y-4 sm:space-y-6 md:space-y-8 animate-slide-in-left'>
            <div>
              <h1 className='font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-text-light mb-2 sm:mb-3 leading-tight'>
                Discover Your
                <span className='text-accent-gold'> Perfect Beauty</span>
              </h1>
              <div className='divider-gold'></div>
            </div>

            <p className='text-base sm:text-lg lg:text-xl text-text-light/80 max-w-lg leading-relaxed font-light'>
              Welcome to Ancy Friz, your premier destination for professional hair styling and beauty treatments in the heart of Sarajevo.
            </p>

            {/* CTA Buttons */}
            <div className='flex flex-col sm:flex-row gap-3 sm:gap-4 pt-0 sm:pt-2'>
              <Button
                title='Call Now'
                link='tel:+38762741146'
                className='btn-primary px-6 sm:px-8 py-2.5 sm:py-3 text-center text-sm sm:text-base'
              />
              <Button
                title='Get in Touch'
                link='/contact'
                className='btn-secondary px-6 sm:px-8 py-2.5 sm:py-3 text-center text-sm sm:text-base'
              />
            </div>
          </div>

          {/* Right Side - Visual Element (Image or Pattern) */}
          <div className='hidden lg:flex flex-col items-center justify-center animate-slide-in-right'>
            <div className='relative'>
              {/* Luxury Border Frame */}
              <div className='absolute -inset-8 border-2 border-accent-gold/30 rounded-lg'></div>

              {/* Main Image */}
              <div className='relative w-full h-96 bg-gradient-to-br from-accent-gold/10 to-accent-emerald/10 rounded-lg overflow-hidden shadow-lg-gold'>
                <img
                  src='/images/landing/hero-frame.png'
                  alt='Premium Hair Salon'
                  className='w-full h-full object-cover'
                />
              </div>

              {/* Accent Dots */}
              <div className='absolute -bottom-4 -right-4 w-24 h-24 border-2 border-accent-gold/40 rounded-full'></div>
              <div className='absolute -top-4 -left-4 w-16 h-16 border-2 border-accent-gold/20 rounded-full'></div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator - Hidden on mobile */}
        <div className='hidden md:flex absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center space-y-2 animate-bounce'>
          <p className='text-text-light/50 text-sm uppercase tracking-widest'>Scroll</p>
          <svg className='w-6 h-6 text-accent-gold' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 14l-7 7m0 0l-7-7m7 7V3' />
          </svg>
        </div>
      </div>
    </Section>
  );
};

export default HeroBanner;
